import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import GridView from "@material-ui/icons/GridOn";
import ListIcon from "@material-ui/icons/List";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./BasicProjects.css";
import "./BasicProjects2.css";

import { API } from "aws-amplify";
import { deleteEduvanceAITool } from "../../graphql/mutations";
import { listEduvanceAITools } from "../../graphql/queries";

import Backdrop from "@material-ui/core/Backdrop";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import { deleteUserFolder } from "../../utils/deleteUserFolder";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    // width: '60vw',
    backgroundColor: "#a0a0a0",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const BasicProject = (props) => {
  const classes = useStyles();
  let history = useHistory();

  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [basicProjects, setBasicProjects] = useState("");
  const [listview, setListView] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  async function fetchProjects() {
    let nexttoken = "";
    let basicArray = [];

    while (nexttoken !== null) {
      const apiData = await API.graphql({
        query: listEduvanceAITools,
        variables: {
          filter: {
            user: {
              eq: localStorage.getItem(
                "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
              ),
            },
            projectType: { eq: "Basic" },
          },
          limit: 1000,
          nextToken: nexttoken,
        },
      });

      nexttoken = apiData.data.listEduvanceAITools.nextToken;
      apiData.data.listEduvanceAITools.items.forEach((item) => {
        basicArray.push(item);
      });
    }

    setBasicProjects(basicArray);
  }

  const handleCouponModalClose = () => {
    setCouponModalOpen(false);
  };
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const verifyCoupon = () => {
    var couponid = document.getElementById("couponid").value;
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    var jsondata = JSON.parse(userdata);
    var data = `${username}//${jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]}`;
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        // console.log(this.responseText);
        if (this.responseText === "Coupon successfully redeemed") {
          alert("coupon successfully redeemed");
          setCouponModalOpen(false);
          // window.location.reload();
        } else alert(this.responseText);
      }
    });
    xhr.open(
      "POST",
      `https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/coupon?coupon=${couponid}&type=redeem`,
    );
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(data);
  };

  async function deleteProject(projectId) {
    try {
      const username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );

      await deleteUserFolder(username);
      await API.graphql({
        query: deleteEduvanceAITool,
        variables: {
          input: {
            projectname: `${username}//Basic//${projectId}`,
          },
        },
      });
    } catch (err) {
      console.log(err);
    }
  }

  const viewProject = (e) => {
    let plink = e.currentTarget.id.substring(4);
    // console.log("clicke "+ e.currentTarget.id.substring(4));
    history.push(
      `/basicproject/${localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")}/${plink}`,
    );
  };

  return (
    <>
      {/* <div className="mainbodybasic">
            </div> */}
      <Modal
        open={couponModalOpen}
        onClose={handleCouponModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
        BackdropComponent={Backdrop}
      >
        <div className={classes.paper + " text-center"}>
          <TextField
            id="couponid"
            style={{ width: "11rem" }}
            placeholder="Enter Coupon"
          />
          <br></br>
          <br></br>
          <span>Please mail at contact@eduvance.in to get coupon.</span>
          <Button
            variant="contained"
            color="primary"
            component="span"
            onClick={verifyCoupon}
          >
            SUBMIT
          </Button>
        </div>
      </Modal>
      <div>
        <img
          alt="main-background-img"
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          alt="background-img"
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important" }}>Basic</h2>
          </div>
          <div className="col-auto align-self-end">
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {/**************************** projects list starts from here  ****************/}

      <div className="project-list-container">
        <div className="project-list-header">
          <h3>My Projects</h3>
          <div style={{ display: "flex", alignItems: "start" }}>
            <Link to="/basicnew" style={{ textDecoration: "none" }}>
              <p className="createnewbtn">Create New</p>
            </Link>
            <div style={{ padding: "0 1rem" }}>
              <ListIcon
                onClick={() => setListView(true)}
                style={
                  listview
                    ? {
                        background: "#222",
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                    : {
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                }
              />
              <GridView
                onClick={() => setListView(false)}
                style={
                  !listview
                    ? {
                        background: "#222",
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                    : {
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                }
              />
            </div>
          </div>
        </div>

        <div
          className="project-card-list"
          style={
            listview ? { flexDirection: "column" } : { flexDirection: "row" }
          }
        >
          {basicProjects === "" ? (
            <>
              <div className="container selectcontainer">
                <div className="row justify-content-md-center">
                  <div className="col-4 " style={{ paddingLeft: "5vw" }}>
                    <h4>No Projects</h4>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {basicProjects.map((item) => (
                <>
                  {item["projectname"].split("//")[2] !== "untitled" ? (
                    <div
                      key={item["projectname"].split("//")[2]}
                      className="project-card"
                      style={listview ? { width: "100%" } : { width: "15rem" }}
                    >
                      <h4
                        style={
                          listview
                            ? { fontSize: "1.5rem", paddingTop: "1.5rem" }
                            : { fontSize: "1.2rem", paddingTop: "1.5rem" }
                        }
                      >
                        {item["projectname"].split("//")[2]}
                      </h4>

                      <div className="project-btns">
                        <div
                          className="view btns"
                          id={`view${item["projectname"].split("//")[2]}`}
                          onClick={viewProject}
                        >
                          <span>View</span>
                        </div>

                        <div
                          className="delete btns"
                          id={`del${item["projectname"].split("//")[2]}`}
                          onClick={() => {
                            deleteProject(item["projectname"].split("//")[2]);
                          }}
                        >
                          <DeleteIcon />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BasicProject;
